export default __webpack_public_path__ + "static/media/start_selling.fbd25020.svg";